module.exports = __webpack_public_path__ + "img/red-envelope.960f01aa.svg";